import loadsh from 'lodash'
export const AboutUs = [
  {
    id: loadsh.uniqueId(),
    heading: 'Founding',
    description:
      'SpaceX was founded in 2002 by Elon Musk with the goal of reducing space transportation costs to enable the colonization of Mars.',
  },
  {
    id: loadsh.uniqueId(),
    heading: 'Headquarters',
    description:
      'SpaceX is headquartered in Hawthorne, California, which also serves as its primary manufacturing plant.',
  },
  {
    id: loadsh.uniqueId(),
    heading: 'Our Vision',
    description:
      ' To revolutionize space transportation, with the ultimate goal of making life multiplanetary.',
  },
]

export const NavItems = [
  {
    id: loadsh.uniqueId(),
    name: 'History',
  },

  {
    id: loadsh.uniqueId(),
    name: 'Launches',
  },

  {
    id: loadsh.uniqueId(),
    name: 'Rockets',
  },
]
